export const recipeUpgradeListCopy = {
    bannerTitle: 'Upgrade your recipes to Segments',
    bannerBody: (count: number) =>
        `You have ${count} recipes to upgrade. A Segment does the same work with clearer syntax, and we show you any differences before you confirm.`,
    bannerBodyPartWay: (remaining: number, total: number) =>
        `${remaining} of your ${total} recipes are still to upgrade. A Segment does the same work with clearer syntax, and we show you any differences before you confirm.`,
    viewChanges: 'View changes',
    upgradeAll: (count: number) => `Upgrade all ${count}`,
    notYetUpgraded: 'Not yet upgraded',
    upgrade: 'Upgrade',
    cannotUpgrade: "Can't upgrade",
    cannotUpgradeTooltip:
        'This recipe has a syntax error, so it has never run. Fix the trigger to upgrade it.',
    upgraded: 'Upgraded',
    upgradedTooltip: (date: string) =>
        `Upgraded on ${date}. This recipe no longer runs. The Segment does.`,
}
